import { Link, useLocation } from "react-router-dom";
import './Streak.css'
import { BadgeImage } from "../../assets/images";
import { useAppContext } from "../../utils/AppContext";
import { useStreak } from "../../hooks/useALSE";
import { navItems } from "../../config";

export default function Streak() {
    const {data: streak, error, loading } = useStreak([]);

    const { streakUpdated } = useAppContext()
    
    const location = useLocation();
    const isActive = (path: string) => path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);
    if (error || loading || !streak || streak.streak < 0 || (streak.streak === 0 && !streakUpdated))
        return null;
      if (!navItems.some((item) => isActive(item.route)))
      return null;

    return (
      <div className={"streak" + (streak.active || streakUpdated ? " active" : "") + (streakUpdated ? " increased" : "")}>
        <Link to='/logros'>
          <img src={BadgeImage} alt="Medalla" />
          <div className="number">{streakUpdated ? streak.streak + 1 : streak.streak}</div>
        </Link>
        <div className="txt">RACHA</div>
      </div>
    );
};

